import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["touchArea"];
import { useFocusRing } from "@react-aria/focus";
import { useHover, usePress } from "@react-aria/interactions";
import { useTouchArea } from "./useTouchArea";
export var useReaction = function useReaction(opts) {
  return useReactionCore(opts);
};
export function useReactionWithTouchArea(_ref) {
  var touchAreaOpts = _ref.touchArea,
      opts = _objectWithoutProperties(_ref, _excluded);

  var _useTouchArea = useTouchArea(touchAreaOpts),
      TouchArea = _useTouchArea.TouchArea,
      touchAreaProps = _useTouchArea.touchAreaProps,
      targetRef = _useTouchArea.targetRef,
      isTouchAreaHovered = _useTouchArea.isHovered,
      isTouchAreaPressed = _useTouchArea.isPressed;

  var reactionResult = useReactionCore(_objectSpread(_objectSpread({}, opts), {}, {
    isTouchAreaHovered: isTouchAreaHovered,
    isTouchAreaPressed: isTouchAreaPressed
  }));
  return _objectSpread(_objectSpread({}, reactionResult), {}, {
    TouchArea: TouchArea,
    touchAreaProps: touchAreaProps,
    targetRef: targetRef
  });
}

var useReactionCore = function useReactionCore(props) {
  var _useHover = useHover({
    isDisabled: props.disabled
  }),
      hoverProps = _useHover.hoverProps,
      isTargetHovered = _useHover.isHovered;

  var _usePress = usePress({
    isDisabled: props.disabled
  }),
      pressProps = _usePress.pressProps,
      isTargetPressed = _usePress.isPressed;

  var _useFocusRing = useFocusRing({
    isTextInput: props.isTextInput
  }),
      focusProps = _useFocusRing.focusProps,
      isFocusVisible = _useFocusRing.isFocusVisible,
      isFocused = _useFocusRing.isFocused;

  var isHover = props.isTouchAreaHovered || isTargetHovered;
  var isPressed = props.isTouchAreaPressed || isTargetPressed;
  var reaction = props !== null && props !== void 0 && props.disabled ? "disabled" : props.pressable && isPressed ? "pressed" : props.focusable && !props.isTextInput && isFocusVisible ? // NOTE(kobayang):
  // input 以外の場合でも isFocused の場合は "focused" reaction を返す挙動が正しいように思えるが、
  // 破壊的な変更になるため、`isFocusVisible` の場合にだけ "focused" を当てる。
  "focused" : props.focusable && props.isTextInput && (isFocused || isFocusVisible) ? "focused" : props.hoverable && isHover ? "hover" : "normal";

  var targetProps = _objectSpread(_objectSpread(_objectSpread({}, props.hoverable ? hoverProps : {}), props.focusable ? focusProps : {}), props.pressable ? pressProps : {});

  return {
    reaction: reaction,
    isHover: isHover,
    isPressed: isPressed,
    isFocused: isFocusVisible,
    isDisabled: (props === null || props === void 0 ? void 0 : props.disabled) || false,
    isTargetHover: isTargetHovered,
    isTargetPressed: isTargetPressed,
    targetProps: targetProps
  };
};
//# sourceMappingURL=useReaction.js.map